<!-- General Section -->
<div class="general-container">
  <!-- Header -->
  <div class="general-header">
    <div class="text-section">
      <div class="sub-header">General</div>
      <div class="sub-header-info">
        Modify the taxonomy settings by renaming the taxonomy and managing queue groups to fit your workflows.
      </div>
    </div>
    <div class="action-section">
      <button class="save-btn" [disabled]="!isSaveEnabled()" (click)="handleSaveChanges()">Save Changes
      </button>

      <button class="cancel-btn" [disabled]="!isSaveEnabled()" (click)="handleCancel()">Cancel
      </button>

    </div>
  </div>

  <div class="segment"></div>

  <!-- Taxonomy Name & Description -->
  <div class="taxonomy-details">
    <div class="field-class">
      <div class="label-class"><label>Taxonomy Name</label></div>
      <div class="input-class">
        <input type="text" [(ngModel)]="taxonomy.name" name="taxonomyName" placeholder="Enter taxonomy name"
          class="custom-input" required />
      </div>
    </div>

    <div class="field-class">
      <div class="label-class"><label>Taxonomy Description</label></div>
      <div class="input-class">
        <textarea class="custom-input-description" placeholder="Enter taxonomy description"
          [(ngModel)]="taxonomy.description" name="taxonomyDescription" rows="4">
        </textarea>
      </div>
    </div>
  </div>

  <div class="segment"></div>

  <!-- Queue Group -->
  <div class="queue-details">
    <div class="field-class">
      <div class="label-class"><label>Queue Group</label></div>
      <div class="input-class">
        <mat-form-field appearance="outline" class="full-width" >
          <!-- <mat-label>Queue Group</mat-label> -->
          <mat-select [formControl]="queueGroups" multiple (openedChange)="onDropdownToggle($event)">
            <!-- Trigger shows count -->
            <mat-select-trigger>
              <div class="selected-indicator">
                <span>{{ selectedGroups.length }}</span>
                <span>selected</span>
              </div>
            </mat-select-trigger>

            <!-- Custom Search Input (using ng-container) -->
            <ng-container>
              <div class="search-container" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline">
                  <input matInput
                         placeholder="Search queue group"
                         [(ngModel)]="searchText"
                         (ngModelChange)="filterQueueGroups()"
                         class="search-input" />
                </mat-form-field>
              </div>
            </ng-container>

            <!-- Selected -->
            <mat-optgroup *ngIf="filteredQueueGroups.selected.length" label="Selected">
              <mat-option *ngFor="let group of filteredQueueGroups.selected" [value]="group.name"
                (click)="onGroupSelectChange(group, $event)">
                <mat-checkbox [checked]="group.selected">{{ group.name }}</mat-checkbox>
              </mat-option>
            </mat-optgroup>

            <!-- Unselected -->
            <mat-optgroup *ngIf="filteredQueueGroups.unselected.length" label="Unselected">
              <mat-option *ngFor="let group of filteredQueueGroups.unselected" [value]="group.name"
                (click)="onGroupSelectChange(group, $event)">
                <mat-checkbox [checked]="group.selected">{{ group.name }}</mat-checkbox>
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>

        <!-- Selected Groups Display -->
        <div *ngIf="selectedGroups.length > 0" class="selected-options">
          <div *ngFor="let selected of selectedGroups" class="selected-option">
            <span>{{ selected }}</span>
            <button type="button" (click)="deselectOption(selected)" class="deselect-btn">
              <img src="../../../../../assets/icons/close.svg" alt="cross-icon">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="segment"></div>

  <!-- Delete Taxonomy -->
  <div class="delete-taxonomy">
    <div class="field-class">
      <div class="label-class"><label>Delete Taxonomy</label></div>
      <div class="input-class">
        <input type="text" [(ngModel)]="deleteInput" name="taxonomyDelete"
          placeholder="Enter exact taxonomy name to confirm deletion" class="custom-input" required />
      </div>
    </div>
    <div class="delete-btn-class">
      <button class="delete-btn" [disabled]="!isDeleteEnabled()"
        (onButtonClick)="handleDeleteTaxonomy(deleteInput)">Delete Taxonomy
      </button>
    </div>
  </div>
</div>


<!-- Fullscreen Confirmation Modal -->
<div *ngIf="showConfirmationPopup" class="fullscreen-modal">
  <div class="modal-content">
    <div class="pop-up-header">
      <img src="../../../../../assets/icons/save-alter.svg" alt="save-alert">
      <span>Save Changes?</span>
    </div>

    <div class="info">
      You are exiting without saving changes. Do you want to save all your changes before you exit?
    </div>

    <div class="modal-actions">
      <button class="save-btn" [disabled]="!isSaveEnabled()" (click)="confirmSaveChanges()">Save Changes</button>
      <button class="cancel-btn" [disabled]="!isSaveEnabled()" (click)="cancelSave()">Cancel</button>
    </div>
  </div>
</div>
